import styled from "@emotion/styled";

const StyledNotificationItem = styled("div")`
  & + & {
    border-top: 1px solid var(--border-color-default);
  }
`;

export default StyledNotificationItem;
